import script from "./Decpro.vue?vue&type=script&lang=ts&setup=true"
export * from "./Decpro.vue?vue&type=script&lang=ts&setup=true"

import "./Decpro.vue?vue&type=style&index=0&id=01b48794&scoped=true&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01b48794"]])

export default __exports__